export default __webpack_public_path__ + "static/media/all-landingPage.a955dcb7.png";